import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import axios from 'axios';
import { handleErrors, headerBuilder, paramBuilder, validateOptions } from '../http';
import { buildAgentPath } from '../../helpers';
export var fetchAgentHandlers = function fetchAgentHandlers() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('fetchAgentHandlers', [], options);
  return axios.get("".concat(buildAgentPath(options), "/app/api/v1/handlers"), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      handlers: response.data.handlers
    };
  })["catch"](handleErrors);
};
export var fetchAgentHandler = function fetchAgentHandler() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('fetchAgentHandler', ['handlerSlug'], options);
  return axios.get("".concat(buildAgentPath(options), "/app/api/v1/handlers/").concat(options.handlerSlug), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      handler: response.data.handler
    };
  })["catch"](handleErrors);
};
export var createAgentHandler = function createAgentHandler() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('createAgentHandler', ['handler'], options);
  return axios.post("".concat(buildAgentPath(options), "/app/api/v1/handlers/"), options.handler, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      handler: response.data.handler
    };
  })["catch"](handleErrors);
};
export var updateAgentHandler = function updateAgentHandler() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('updateAgentHandler', ['handlerSlug', 'handler'], options);
  return axios.put("".concat(buildAgentPath(options), "/app/api/v1/handlers/").concat(options.handlerSlug), options.handler, {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      handler: response.data.handler
    };
  })["catch"](handleErrors);
};
export var deleteAgentHandler = function deleteAgentHandler() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('deleteAgentHandler', ['handlerSlug'], options);
  return axios["delete"]("".concat(buildAgentPath(options), "/app/api/v1/handlers/").concat(options.handlerSlug), {
    params: paramBuilder(options),
    headers: headerBuilder(options)
  }).then(function (response) {
    return {
      handler: response.data.handler
    };
  })["catch"](handleErrors);
};
export var testAgentHandler = function testAgentHandler() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  validateOptions('testAgentHandler', ['agentSlug', 'handlerSlug', 'parameters'], options);
  var parameters = options.parameters.reduce(function (params, parameter) {
    params[parameter.name] = parameter.value;
    return params;
  }, {});
  return axios.post("".concat(buildAgentPath(options), "/app/api/v1/handlers/").concat(options.handlerSlug, "/execute"), _objectSpread({}, parameters))["catch"](handleErrors);
};